import { createAsyncThunk } from '@reduxjs/toolkit';
import cigarProductionPlansApi from '../../../api/cigarProductionPlansApi';
import { SetAlertAndClose } from '../AlertReducer';

// ---------------------------------------------------------------------

const REDUCER_NAME = 'cigarProductionPlans';

export const GetCigarProductionPlans = createAsyncThunk(
  `${REDUCER_NAME}/getCigarProductionPlans`,
  async (params: { includeCompleted?: boolean } | undefined, thunkAPI) => {
    const res = await cigarProductionPlansApi.get(params);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetCigarProductionPlanSummaries = createAsyncThunk(
  `${REDUCER_NAME}/getCigarProductionPlanSummaries`,
  async (_, thunkAPI) => {
    const res = await cigarProductionPlansApi.getSummaries();

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const CreateCigarProductionPlan = createAsyncThunk(
  `${REDUCER_NAME}/createCigarProductionPlan`,
  async (data: any, thunkAPI) => {
    const res = await cigarProductionPlansApi.create(data);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const UpdateCigarProductionPlan = createAsyncThunk(
  `${REDUCER_NAME}/updateCigarProductionPlan`,
  async ({ data, id }: { data: any; id: string }, thunkAPI) => {
    const res = await cigarProductionPlansApi.update(data, id);

    if (res.status === 200) {
      if (res.data?.status === 'success') {
        thunkAPI.dispatch(SetAlertAndClose({ data: res.data }));
      }
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const DeleteCigarProductionPlan = createAsyncThunk(
  `${REDUCER_NAME}/deleteCigarProductionPlan`,
  async (id: string, thunkAPI) => {
    const res = await cigarProductionPlansApi.remove(id);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const TakeInWorkCigarProductionPlan = createAsyncThunk(
  `${REDUCER_NAME}/takeInWorkCigarProductionPlan`,
  async ({ data, id }: { data: any; id: string }, thunkAPI) => {
    const res = await cigarProductionPlansApi.takeInWork(id, data);

    if (res.status === 200) {
      if (res.data?.status === 'success') {
        thunkAPI.dispatch(SetAlertAndClose({ data: res.data }));
      }
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);
